import { useTranslation } from "react-i18next";
import { MicroFrontendLink } from "@entur-partner/app-shell";
import { Breadcrumbs as EPBreadcrumbs } from "@entur-partner/common";
import { BreadcrumbItem } from "@entur/menu";
import { useLocation, useMatches, useNavigate } from "@tanstack/react-router";

import { useBreadcrumbLookup } from "./breadcrumbLookup.ts";
import { PARENT_ROUTES, type Parent } from "./parentRoutes.ts";

export const Breadcrumbs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const matches = useMatches();
  const breadcrumbLookup = useBreadcrumbLookup();
  const { t } = useTranslation();

  const machineMatch = matches.find((m) => m.routeId === "/machines/$machineId");
  const parentFrom = (machineMatch?.search as { from?: Parent } | undefined)?.from;
  const parentRoute = parentFrom ? PARENT_ROUTES[parentFrom] : undefined;

  const parentItem = parentRoute ? (
    <BreadcrumbItem
      key="parent"
      as={MicroFrontendLink}
      navigate={() => navigate({ to: parentRoute.path })}
      href={parentRoute.path}
    >
      {t(parentRoute.labelKey)}
    </BreadcrumbItem>
  ) : undefined;

  return <EPBreadcrumbs prependBreadcrumbItem={parentItem} pathname={pathname} onBreadcrumbLookup={breadcrumbLookup} />;
};
